import { useTranslation } from 'react-i18next';
import { useFetchTransactionRestrictions } from './useFetchTransactionRestrictions';
import { IMatter } from '../interface';
import { getMatterRestrictionWarnings } from '../helpers/transactionRestrictionMessageHelper';

/**
 * Warning-level restrictions of the selected matter, to be shown inline under the matter field.
 *
 * The restrictions were already fetched to decide whether this matter could be picked at all, so
 * this reads the same cache entry rather than causing another round trip. Errors are ignored on
 * purpose: a failing check is reported by the restriction container that gated the selection, and
 * an unreachable check must not put a warning the user cannot act on under their matter field.
 */
export const useMatterRestrictionWarnings = (matter?: IMatter): string[] => {
  const { t } = useTranslation();

  const { data: matterTransactionRestrictions } = useFetchTransactionRestrictions({
    matterId: matter?.id,
    enabled: !!matter?.id,
  });

  return getMatterRestrictionWarnings(t, matter, matterTransactionRestrictions);
};
